import React from "react";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { useCatalogDownload } from "../../hooks";
import "./index.css";

const CatalogDownload: React.FC = () => {
  const { handleDownload, isDownloading, isAvailable, selectedCount } =
    useCatalogDownload();

  return (
    <>
      <button
        onClick={handleDownload}
        disabled={!isAvailable || isDownloading}
        className={`
        flex items-center gap-2 px-4 py-2 rounded-xl transition-all h-fit min-w-[12rem] justify-center text-[#FFFFFF]
        button-download-spin
        ${
          isAvailable && !isDownloading
            ? "bg-[#0EA5E9] cursor-pointer"
            : "bg-[#D9D9D9] cursor-not-allowed"
        }
      `}
      >
        {isDownloading ? (
          <Spin
            indicator={<LoadingOutlined spin />}
            className="w-6 h-6 flex items-center justify-center"
          />
        ) : (
          <ArrowDownTrayIcon className="w-6 h-6" />
        )}
        <span className="text-[1rem] font-[500] leading-none">
          {isDownloading
            ? "Processing..."
            : `Download${selectedCount ? ` (${selectedCount})` : ""}`}
        </span>
      </button>
    </>
  );
};

export default CatalogDownload;
